import {
  type AuthorityNotificationShape,
  fetchAuthorityNotificationListByAuthority
} from 'Services/SalesManagement/Features/Notification/notificationSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { SEVERITY_LEVELS } from 'Util/constants'
import ClearTwoToneIcon from '@mui/icons-material/ClearTwoTone'
import { Alert, Box, Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { unwrapResult } from '@reduxjs/toolkit'
import { Markup } from 'interweave'
import { type FC, useEffect, useState } from 'react'
import { t } from 'ttag'

function getSeverityByType(type: string) {
  switch (type) {
    case 'info':
      return SEVERITY_LEVELS.INFO
    case 'warning':
      return SEVERITY_LEVELS.ERROR
    case 'admonition':
      return SEVERITY_LEVELS.WARNING
    default:
      return SEVERITY_LEVELS.INFO
  }
}

const StyledAlert = styled(Alert)(({ theme }) => ({
  borderRadius: 0,
  borderBottom: `1px solid ${theme.palette.action.selected}`,
  '& .MuiAlert-icon': { display: 'flex', alignItems: 'center' },
  '& .MuiAlert-message': {
    display: 'flex',
    alignItems: 'center'
  },
  '& .MuiAlert-action': {
    display: 'flex',
    alignItems: 'center'
  }
}))

const NotificationBanner: FC = () => {
  const dispatch = useAppDispatch()

  const [authorityNotifications, setAuthorityNotifications] = useState<
    AuthorityNotificationShape[]
  >([])

  const { authorityNotificationsByAuthority } = useTypedSelector(state => state.notification)

  const handleNotificationClear = (id: number) => {
    setAuthorityNotifications(prevState => prevState.filter(notification => notification.id !== id))
  }

  useEffect(() => {
    setAuthorityNotifications(authorityNotificationsByAuthority)
  }, [authorityNotificationsByAuthority])

  useEffect(() => {
    let isMounted = true
    dispatch(fetchAuthorityNotificationListByAuthority())
      .then(unwrapResult)
      .then(res => {
        if (isMounted) setAuthorityNotifications(res.results)
      })
    return () => {
      isMounted = false
    }
  }, [dispatch])

  return (
    <Box>
      {authorityNotifications.map(notification => (
        <StyledAlert
          key={notification.id}
          severity={getSeverityByType(notification.type)}
          action={
            <Button
              color="inherit"
              onClick={() => handleNotificationClear(notification.id)}
              endIcon={<ClearTwoToneIcon />}
            >
              {t`Close`}
            </Button>
          }
        >
          <Markup content={notification.content_fi} />
        </StyledAlert>
      ))}
    </Box>
  )
}

export default NotificationBanner
